/* D/R r66 - UX fixes (display / validation messages only; no cart, price, discount or size-required logic).
   M8 sold-out PDP: no pre-selected unavailable size, qty disabled when nothing can be bought.
   M9 quantity: never 0 / negative, inline message, no failed add request.
   M14 contact form: inline email errors. */
(function () {
  if (window.drR66) return; window.drR66 = 1;

  /* ---------- M9: quantity >= 1 ---------- */
  function qtyMsg(input, text) {
    var host = input.closest('.product-form__quantity') || input.parentNode;
    var m = host.querySelector('.dr-qty-msg');
    if (!text) { if (m) m.hidden = true; return; }
    if (!m) { m = document.createElement('p'); m.className = 'dr-qty-msg'; m.setAttribute('role', 'alert'); host.appendChild(m); }
    m.textContent = text; m.hidden = false;
  }
  function bad(input) { var n = parseInt(input.value, 10); return !(n >= 1); }
  function isPdpQty(t) { return t && t.matches && t.matches('input.quantity__input[name="quantity"]'); }
  document.addEventListener('focusin', function (e) { if (isPdpQty(e.target)) { e.target.setAttribute('inputmode', 'numeric'); e.target.setAttribute('pattern', '[0-9]*'); } });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!isPdpQty(t)) return;
    if (bad(t)) { t.value = 1; qtyMsg(t, 'Quantity must be at least 1.'); } else qtyMsg(t, '');
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
    var fid = f.getAttribute('id'); if (!fid) return; /* f.id would return the hidden <input name="id"> */
    var q = document.querySelector('input.quantity__input[name="quantity"][form="' + fid + '"]');
    if (!q || !bad(q)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    q.value = 1; qtyMsg(q, 'Quantity must be at least 1.'); q.focus();
  }, true);

  /* ---------- M8: sold-out PDP ---------- */
  function addBtn(info) { return info.querySelector('form[data-type="add-to-cart-form"] [name="add"]'); }
  function syncSoldOut(info) {
    var add = addBtn(info); if (!add) return;
    var so = add.disabled && !add.dataset.drSizePending && add.getAttribute('aria-disabled') !== 'true' && /sold out|unavailable/i.test(add.textContent || '');
    info.classList.toggle('dr-soldout', so);
    var q = info.querySelector('input.quantity__input[name="quantity"]');
    if (q) {
      if (so && !q.disabled) { q.disabled = true; q.dataset.drDis = '1'; }
      else if (!so && q.dataset.drDis) { q.disabled = false; delete q.dataset.drDis; }
      info.querySelectorAll('quantity-input .quantity__button').forEach(function (b) {
        if (so && !b.disabled) { b.disabled = true; b.dataset.drDis = '1'; }
        else if (!so && b.dataset.drDis) { b.disabled = false; delete b.dataset.drDis; }
      });
    }
    if (so) {
      info.querySelectorAll('variant-selects fieldset.product-form__input').forEach(function (fs) {
        var radios = fs.querySelectorAll('input[type=radio]');
        if (!radios.length) return;
        var allOut = [].every.call(radios, function (r) { return r.classList.contains('disabled'); });
        if (!allOut) return;
        var chk = fs.querySelector('input[type=radio]:checked');
        if (chk) { chk.checked = false; var lv = fs.querySelector('legend [data-selected-value], legend .form__label-value'); if (lv) lv.textContent = ''; }
      });
    }
  }
  function watch(info) {
    if (info._drR66) return; info._drR66 = 1;
    syncSoldOut(info);
    new MutationObserver(function () { syncSoldOut(info); }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  }
  function scan(root) { (root.querySelectorAll ? root : document).querySelectorAll('product-info').forEach(watch); }

  /* ---------- M14: contact form inline errors ---------- */
  function contact() {
    var form = document.getElementById('ContactForm'); if (!form || form._drR66) return; form._drR66 = 1;
    form.noValidate = true;
    var em = form.querySelector('#ContactForm-email'), ph = form.querySelector('#ContactForm-phone');
    function clear(inp) { inp.removeAttribute('aria-invalid'); var s = form.querySelector('.dr-inline[data-for="' + inp.id + '"]'); if (s) s.remove(); }
    function show(inp, text) {
      clear(inp); inp.setAttribute('aria-invalid', 'true');
      var s = document.createElement('small'); s.className = 'contact__field-error dr-inline'; s.dataset.for = inp.id; s.id = inp.id + '-inline-error'; s.setAttribute('role', 'alert'); s.textContent = text;
      inp.setAttribute('aria-describedby', s.id); (inp.closest('.field') || inp.parentNode).appendChild(s);
    }
    [em, ph].forEach(function (i) { if (i) i.addEventListener('input', function () { clear(i); }); });
    form.addEventListener('submit', function (e) {
      var v = (em.value || '').trim(), msg = '';
      if (!v) msg = 'Please enter your email address.'; else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) msg = 'Please enter a valid email address.';
      var pmsg = (ph && ph.value && !/^[0-9-]*$/.test(ph.value)) ? 'Please use numbers and hyphens only.' : '';
      if (!msg && !pmsg) return;
      e.preventDefault();
      if (msg) show(em, msg); if (pmsg) show(ph, pmsg);
      (msg ? em : ph).focus();
    });
  }

  function init() {
    scan(document); contact();
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('product-info')) watch(n); else scan(n); } }); }); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
